import { env } from '@/lib/env';

export const APP_NAME = 'H2O Administration';
export const BASE_URL = env.VITE_BASE_URL;
